import { MAX_OPACITY, MIN_OPACITY } from '../../constants/constants';

interface LegendGradientProps {
  color: string;
  minOpacity?: number;
  maxOpacity?: number;
}

export const LegendGradient = ({
  color,
  minOpacity = MIN_OPACITY,
  maxOpacity = MAX_OPACITY,
}: LegendGradientProps) => (
  <svg
    className="w-full"
    xmlns="http://www.w3.org/2000/svg"
    width="254"
    height="32"
    viewBox="0 0 254 32"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 32L254 0V26.9385C254 29.6999 251.761 31.9385 249 31.9385H0V32Z"
      fill="url(#paint0_linear_gradient)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_gradient"
        x1="3.27487e-07"
        y1="32"
        x2="253.512"
        y2="11.2372"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor={color} stopOpacity={minOpacity} />
        <stop offset="1" stopColor={color} stopOpacity={maxOpacity} />
      </linearGradient>
    </defs>
  </svg>
);
